import Separator from '@doordash/component-separator'
import {
  Text,
  Colors,
  Icon,
  Inset,
  Stack,
  InlineChildren,
} from '@doordash/design-language'
import * as React from 'react'

import {
  ContentContainer,
  ListIcon,
  ListMenu,
  ListMenuContainer,
  ListTitleContainer,
  ProgressLine,
  Badge,
  BadgeText,
} from './styles'

type ListItemState = {
  showContent: boolean
}

type ListItemProps = {
  title: (any) => string
  children?: any
  step?: number
  isActive?: boolean
  isComplete?: boolean
  showSeparator?: boolean
  trackClick?: (stepName: string, data: object) => Promise<any>
  stepName?: string
  badgeText?: string
  alwaysEnabled?: boolean
  activeBadge?: boolean
  showProgressLine?: boolean
}

export default class ListItem extends React.Component<
  ListItemProps,
  ListItemState
> {
  public static defaultProps = {
    isComplete: false,
    showSeparator: true,
    activeBadge: false,
  }

  constructor(props) {
    super(props)
    this.state = {
      showContent: false,
    }
  }

  public onClick() {
    const {
      isActive,
      isComplete,
      trackClick,
      stepName,
      alwaysEnabled,
    } = this.props

    if (!isActive) {
      trackClick(stepName, {
        isComplete,
        showContent: this.state.showContent,
      })
      if (!isComplete || alwaysEnabled) {
        this.setState({ showContent: !this.state.showContent })
      }
    }
  }

  public render() {
    const {
      isActive,
      title,
      children,
      step,
      isComplete,
      badgeText,
      alwaysEnabled,
      activeBadge,
      showProgressLine,
    } = this.props
    return (
      <ListMenuContainer showProgressLine={showProgressLine}>
        <ProgressLine isComplete={isComplete} isActive={isActive} />
        <ListIcon
          isActive={isActive}
          isComplete={isComplete}
          size={Inset.Sizes.XxxSmall}
        >
          {isComplete ? (
            <Icon
              type={Icon.Types.Check}
              size={Icon.Sizes.Medium}
              color={Colors.SystemGrey10}
            />
          ) : (
            <Text
              color={!isActive ? Colors.SystemGrey60 : Colors.SystemBlack}
              styles={Text.Styles.ListRowTitleLarge}
            >
              {step}
            </Text>
          )}
        </ListIcon>
        <ListTitleContainer>
          <Inset isStretched={true} size={Inset.Sizes.XxxSmall}>
            <ListMenu
              onClick={this.onClick.bind(this)}
              disabled={(alwaysEnabled && isComplete) || isActive}
            >
              <Text
                display={Text.DisplayModes.Flex}
                textAlign={Text.TextAlignments.Left}
                styles={
                  isActive
                    ? Text.Styles.ListRowTitleLarge
                    : Text.Styles.ListRowSecondaryLarge
                }
                overflow={Text.Overflows.BreakWord}
              >
                {title(isComplete)}
              </Text>
              {activeBadge && isActive && badgeText && (
                <Badge>
                  <BadgeText>{badgeText}</BadgeText>
                </Badge>
              )}
              {(alwaysEnabled || (!isActive && !isComplete)) && (
                <InlineChildren>
                  {badgeText && (
                    <Badge>
                      <BadgeText>{badgeText}</BadgeText>
                    </Badge>
                  )}
                  <Icon
                    type={
                      this.state.showContent
                        ? Icon.Types.ChevronUp
                        : Icon.Types.ChevronDown
                    }
                    size={Icon.Sizes.Medium}
                    color={Colors.SystemGrey60}
                  />
                </InlineChildren>
              )}
            </ListMenu>
            {(this.state.showContent || isActive) && (
              <ContentContainer>
                <Stack size={Stack.Sizes.XxSmall} />
                {(alwaysEnabled || !isComplete) && children}
              </ContentContainer>
            )}
          </Inset>
          {this.props.showSeparator && (
            <Separator
              verticalMargin={Separator.Sizes.Small}
              type={Separator.Types.FullBorder}
            />
          )}
        </ListTitleContainer>
      </ListMenuContainer>
    )
  }
}
